import { connect } from 'react-redux';
import StreamSelect from '../components/StreamSelect';
import { setStream } from '../../aovivoBar/actions/MediaPlayerActions';

const mapStateToProps = (state) => ({
    currentStreamId: state.aovivoBar.MediaPlayer.currentStreamId,
    availableStreams: state.aovivoBar.MediaPlayer.availableStreams,
});


const mapDispatchToProps = (dispatch) => ({
    setStream: (streamId, userInitiated, history) => {
        dispatch(setStream(streamId, userInitiated, history));
    },
});


const StreamSelectContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(StreamSelect);

export default StreamSelectContainer;
